import type {
  CreateUserJsonDTO,
  UpdateUserJsonDTO,
} from "@/modules/users/domain/contracts";
import type {
  BanUserServiceResult,
  CreateUserServiceResult,
  DeleteUserServiceResult,
  UnbanUserServiceResult,
  UpdateUserServiceResult,
  UserByIdResult,
  UsersListResult,
} from "@/modules/users/domain/types";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export const usersApi = {
  async list(query: OffsetPageQueryDTO): Promise<UsersListResult> {
    const url = new URL(`${config.apiUrl}/users`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<UsersListResult>(url.toString());
  },
  async get(id: string): Promise<UserByIdResult> {
    return fetcher.get<UserByIdResult>(`${config.apiUrl}/users/${id}`);
  },
  async create(input: CreateUserJsonDTO) {
    return fetcher.post<CreateUserServiceResult>(
      `${config.apiUrl}/users`,
      input,
    );
  },
  async update(id: string, input: UpdateUserJsonDTO) {
    return fetcher.put<UpdateUserServiceResult>(
      `${config.apiUrl}/users/${id}`,
      input,
    );
  },
  async remove(id: string) {
    return fetcher.delete<DeleteUserServiceResult>(
      `${config.apiUrl}/users/${id}`,
    );
  },
  async ban(id: string, data: { reason?: string; expires?: string }) {
    return fetcher.post<BanUserServiceResult>(
      `${config.apiUrl}/users/${id}/ban`,
      data,
    );
  },
  async unban(id: string) {
    return fetcher.post<UnbanUserServiceResult>(
      `${config.apiUrl}/users/${id}/unban`,
    );
  },
};
